import React from 'react';
import { Footer as SharedFooter, type AgencyContactInfo, type FooterLink } from '@insieme_dev/shared-ui-react';
import appConfig, { AGENCY_ID, REALIZATION_YEAR } from '../../config/appConfig';
import { useTranslation } from 'react-i18next';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

interface FooterProps {
  agencyData?: AgencyContactInfo;
}

const Footer: React.FC<FooterProps> = ({ agencyData }) => {
  const { t } = useTranslation();

  const footerLinks: FooterLink[] = [
    { label: t("navigation.aboutUsLinkTitle"), url: "/chi-siamo", title: t("navigation.aboutUsLinkTitle") },
    { label: t("navigation.valutationLinkTitle"), url: "/valutazione", title: t("navigation.valutationLinkTitle") },
    { label: t("navigation.contactUsLinkTitle"), url: "/contatti", title: t("navigation.contactUsLinkTitle") }
  ];

  return (
    <SharedFooter
      agencyData={agencyData}
      config={{
        agency: {
          customPhone: appConfig.agency.customPhone || "",
          customPhone2: appConfig.agency.customPhone2 || "",
          customMobile: appConfig.agency.customMobile || "",
          customMobile2: appConfig.agency.customMobile2 || "",
          customEmail: appConfig.agency.contactEmail || "",
          customAddress: appConfig.agency.customAddress || "",
        },
        ui: {
          footer: {
            showAddress: appConfig.ui.footer.showAddress,
            showTel1: appConfig.ui.footer.showTel1,
            showTel2: appConfig.ui.footer.showTel2,
            showMobile1: appConfig.ui.footer.showMobile1,
            showMobile2: appConfig.ui.footer.showMobile2,
            showEmail: appConfig.ui.footer.showEmail,
            showExternalLink: appConfig.ui.footer.showExternalLink,
          }
        },
        copyright: {
          year: Number(REALIZATION_YEAR),
          companyName: "Insieme srl.",
          companyUrl: "https://www.gruppoinsieme.it"
        }
      }}
      links={footerLinks}
      className="art-footer"
      aboutUsContent={undefined}
      apiConfig={!agencyData ? {
        apiBaseUrl: API_BASE_URL,
        agencyId: Number(AGENCY_ID)
      } : undefined}
      privacyLinks={{
        datiSocietari: "/dati",
        privacy: "/privacy",
        cookies: "/cookies"
      }}
      onBackToTop={() => {
        //console.log('Back to top clicked - Casagrande');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
    />
  );
};

export default Footer;